import React from "react";
import ProgressTracker, { ProgressTrackerStep } from "@amzn/meridian/progress-tracker";
import { ProgressTrackerComponentProps } from "./types";

export const ProgressTrackerComponent: React.FC<ProgressTrackerComponentProps> = ({
    currentStep,
    steps,
    compact = false,
}) => {
    return (
        <ProgressTracker direction="row" compact={compact} autoTrackLength={true}>
            {steps.map((label, index) => (
                <ProgressTrackerStep
                    key={index}
                    type={
                        index === currentStep ? "present" : index < currentStep ? "past" : "future"
                    }
                    label={<span>{label}</span>}
                    showLabel={true}
                />
            ))}
        </ProgressTracker>
    );
};
